const topMain = () => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    const jsSecBg = document.getElementById('jsSecBg');
    const jsSecMain = document.getElementById('jsSecMain');
    const jeSecInfo = document.getElementById('jeSecInfo');
    let bgWrap = jsSecBg.querySelector('.js-bg-wrap');
    const jsSecConcept = document.getElementById('jsSecConcept');
    const jsFooter = document.getElementById('jsFooter');


    ScrollTrigger.create({
      trigger: jeSecInfo,
      start: "top 90%",
      endTrigger: jsSecConcept,
      end: "100% 100%",
      toggleClass: { targets: bgWrap, className: "act" },
      // endTrigger: body,
      // end: "bottom+=10% top",
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: jeSecInfo,
      start: "top 90%",
      endTrigger: 'body',
      end: "100% 0%",
      toggleClass: { targets: bgWrap, className: "act-dot" },
      // endTrigger: body,
      // end: "bottom+=10% top",
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: jsFooter,
      start: "0% 100%",
      endTrigger: 'body',
      end: "100% 0%",
      toggleClass: { targets: bgWrap, className: "none-dot" },
      // endTrigger: body,
      // end: "bottom+=10% top",
      // markers: true,
    });


    let mainLead = jsSecMain.querySelector('.js-main-lead');
    let mainBorder = jsSecMain.querySelector('.js-main-border');
    let mainCopy = jsSecMain.querySelector('.js-main-copy');

    ScrollTrigger.create({
      trigger: 'main',
      start: "0% 0%",
      endTrigger: 'body',
      end: "100% 0%",
      pin: jsSecMain,
      pinSpacing: false,
      // markers: true,
    });


    setTimeout(() => {
      mainLead.classList.add('act')
      mainBorder.classList.add('act')
    }, 500);
    setTimeout(() => {
      mainCopy.classList.add('act')
    }, 900);
    setTimeout(() => {
      // mainLead.classList.remove('act')
      // mainBorder.classList.remove('act')
      // mainCopy.classList.remove('act')
    }, 5000);


    ScrollTrigger.create({
      trigger: 'main',
      start: "10 0%",
      onEnter: () => {
        // mainLead.classList.remove('act')
        mainLead.classList.add('none')
      },
      onLeaveBack: () => {
        mainLead.classList.remove('none')
      },
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: 'main',
      start: "10 0%",
      onEnter: () => {
        // mainCopy.classList.remove('act')
        mainCopy.classList.add('none')
      },
      onLeaveBack: () => {
        mainCopy.classList.remove('none')
      },
      // markers: true,
    });

  }

}
export default topMain;